import { api } from "@/lib/api";
import { hasAnalyticsConsent } from "@/lib/consent";

// Suivi interne, fire-and-forget (sans cookie) — uniquement si consentement mesure d'audience.
export function track(type, name) {
  if (!hasAnalyticsConsent()) return;
  try {
    api.post("/track", { type, name }).catch(() => {});
  } catch {
    /* ignore */
  }
}

export const trackClick = (name) => track("click", name);
export const trackPageview = (name) => track("pageview", name);
